var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGuestsIconSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9583 18.125C25.6276 18.125 27.7916 20.289 27.7916 22.9583V25.375H25.3749M19.3333 13.1394C21.4179 12.6028 22.9583 10.7105 22.9583 8.45832C22.9583 6.20618 21.4179 4.31381 19.3333 3.77726M15.7083 8.45833C15.7083 11.1277 13.5443 13.2917 10.8749 13.2917C8.20554 13.2917 6.04158 11.1277 6.04158 8.45833C6.04158 5.78896 8.20554 3.625 10.8749 3.625C13.5443 3.625 15.7083 5.78896 15.7083 8.45833ZM6.04158 18.125H15.7083C18.3776 18.125 20.5416 20.289 20.5416 22.9583V25.375H1.20825V22.9583C1.20825 20.289 3.37221 18.125 6.04158 18.125Z",
    stroke: "#14489D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGuestsIconSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/guestsIcon_selected.9583d2cac061849b5ed243cd1d21b375.svg";